/** 日历内单击查看、双击编辑共用一份等待状态，避免第一击先弹出详情而吞掉第二击。
 * 月历、周安排及空白日期共用；切换期间、筛选或卸载时丢弃尚未执行的点击。
 * 手机/触笔点击立即查看，避免为桌面双击等待 450ms；编辑/新增仍由明示按钮进入。
 * 键盘/辅助设备的普通激活不延迟；Shift+Enter 提供双击动作的键盘替代。
 */
import { useCallback, useEffect, useRef } from "react";

export default function useScheduleCalendarGesture(context, { singleTap = false } = {}) {
  const pending = useRef(null);
  const pointerType = useRef("");
  const cancel = useCallback(() => { clearTimeout(pending.current); pending.current = null; }, []);
  useEffect(() => cancel, [context, singleTap, cancel]);
  return (single, double) => ({
    onPointerDown: (event) => { pointerType.current = event.pointerType; },
    onClick: (event) => {
      event.stopPropagation(); cancel();
      // 触屏连点不能被解释成编辑/新增：第一下立即反馈，浏览器合成的第二击不重复开窗。
      // 同时检查真实指针，保证大屏触控设备也不必等待鼠标双击窗口。
      if (singleTap || ["touch", "pen"].includes(pointerType.current)) {
        if (event.detail < 2) single();
        return;
      }
      if (!double || event.detail === 0) { single(); return; }
      // 浏览器在第二击后派发 dblclick；留足窗口，第二击本身不再安排详情弹窗。
      if (event.detail === 1) pending.current = setTimeout(() => { pending.current = null; single(); }, 450);
    },
    onDoubleClick: (event) => {
      event.stopPropagation(); cancel();
      if (!singleTap && !["touch", "pen"].includes(pointerType.current)) (double || single)();
    },
    onKeyDown: (event) => {
      if (double && event.shiftKey && event.key === "Enter") { event.preventDefault(); event.stopPropagation(); cancel(); double(); }
    },
    "aria-keyshortcuts": double ? "Shift+Enter" : undefined,
  });
}
